module.exports = "/static/assets/410f44152b97ae6adf77230276c0868d.png";